module.exports = __webpack_public_path__ + "img/amazon-google-home.7afe8649.jpg";